import React from "react";
import { FaBookOpen, FaPen } from "react-icons/fa";
import { MdDelete, MdFastfood } from "react-icons/md";
import { useDispatch } from "react-redux";
import { deleteFourniture } from "../JS/actions/fournitures";

import "./Fournitures.css";

const Fournitures = ({ fourniture }) => {
  const dispatch = useDispatch();
  const handleDelete = () => {
    const result = window.confirm("are you sure");
    if (result) {
      dispatch(deleteFourniture(fourniture._id));
    }
  };
  return (
    <div class="main-container">
      <div class="heading">
        {/* <h1 class="heading__title">Stock Nourritures</h1> */}
      </div>
      <div class="cardss">
        <div class="cardd card-5">
          <div class="card__icon">
            <b> {fourniture.title} </b>
            <FaBookOpen style={{ fontSize: "30px", color: "#38e1b0" }} />{" "}
          </div>
          <p class="card__exit">
            {/* <i class="fas fa-times"></i> */} Quantity : {fourniture.qte}
          </p>
          <p class="card__title">{fourniture.description}</p>
          <p class="card__apply">
            <a class="card__link" href="#">
              Delete{" "}
              <MdDelete
                onClick={handleDelete}
                style={{ color: "red", fontSize: "22px" }}
              />{" "}
            </a>{" "}
            <a class="card__link" href="#">
              Update{" "}
              <FaPen
                // onClick={handleEvent}
                style={{ color: "green", fontSize: "18px" }}
              />
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Fournitures;
